import MinhaConta from '../pages/Inicio/MinhaConta/Menu'
import GrupoDeAcesso from '../pages/Admin/GrupoDeAcesso/Menu'
import Usuarios from '../pages/Admin/Usuarios/Menu'
import Pokemons from '../pages/App/Pokemons/Menu'
// import Golpes from '../pages/App/Golpes/Menu'

const MenuDefault = [{
	titulo: 'Início',
	icone: 'menu-icon fa fa-tachometer',
	action: false,
	visualizar: false,
	submenu: [...MinhaConta]
},
{
	titulo: 'App',
	icone: 'menu-icon fa fa-desktop',
	action: false,
	visualizar: false,
	submenu: [...Pokemons]
},
{
	titulo: 'Admin',
	icone: 'menu-icon fa fa-cog',
	action: false,
	visualizar: false,
	submenu: [...GrupoDeAcesso, ...Usuarios,]
}]

export default MenuDefault
